import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ProfileNav from '../ProfileNav/';
import './ProfileView.scss';

const getTitle = name => {
  if (name !== 'null' && name !== '' && name !== null && name !== undefined) {
    return name + '\'s Profile';
  }
  return undefined;
};

export const ProfileView = ({ firstName, children }) => (
  <div className="ProfileView">
    <div className="ProfileTitle">
      <h2 className="ProfileTitle__Text">{getTitle(firstName)}</h2>
    </div>
    <div className="row">
      <div className="col-md-3 ProfileView__Nav">
        <ProfileNav />
      </div>
      <div className="col-md-9 ProfileView__Content">
        {children}
      </div>
    </div>
  </div>
);

ProfileView.propTypes = {
  children: PropTypes.node,
  firstName: PropTypes.string,
};

const mapStateToProps = state => {
  console.log(state);
  return ({
    firstName : state.auth.firstName,
  });
};

export default connect(mapStateToProps)(ProfileView);



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/components/ProfileView/index.js